import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';

import SumsubWebSdk from '@sumsub/websdk-react';
import amplitude from 'amplitude-js';
import { toggleModalWithTimer, toggleSpinner } from 'apps/auth/actions/appAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import BasePage from 'apps/auth/components/utils/BasePage';
import { INCREASE_LIMITS_DOCUMENTS_SELECTED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { ID_DOCUMENT_TYPE, KYC_PROVIDER } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { SUMSUB } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { KYC_INTRO_SCREEN, SUMSUB_SDK } from 'apps/auth/constants/ComponentNames';
import { AUTH_SEND_MAIN_LINK, SUMSUB_FRAME_TOKEN } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import { useAuth, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';

const AntifraudSumsubFramePage = (props) => {
    const { lang } = useLanguage();
    const { phone } = useAuth();
    const messages = usePageMessages();
    const popupRef = useRef(null);
    const [currentScreen, setCurrentScreen] = useState(KYC_INTRO_SCREEN);
    const { sumsubAccessToken, linkInProgress, linkSuccess, linkFail } = useExtra();
    const { documentSubmittedSpinner } = usePageMessages();

    const configs = {
        lang: lang,
        phone: phone,
    };

    const options = {
        addViewportTag: true,
        adaptIframeHeight: true,
    };

    const handleSumsubMessage = (type, payload) => {
        if (type === 'idCheck.onStepCompleted' && payload.idDocType) {
            amplitude.getInstance().logEvent(INCREASE_LIMITS_DOCUMENTS_SELECTED, {
                [KYC_PROVIDER]: SUMSUB,
                [ID_DOCUMENT_TYPE]: payload.idDocType,
            });
        }
        if (type === 'idCheck.onApplicantStatusChanged') {
            const result = payload?.reviewResult;
            const status = payload?.reviewStatus;
            if (status === 'pending') {
                props.toggleModalWithTimer(true, documentSubmittedSpinner, () => window.location.replace(linkInProgress));
            } else if (status === 'completed' && result) {
                if (result?.reviewAnswer === 'RED') {
                    if (result?.reviewRejectType === 'FINAL') {
                        props.toggleSpinner(true);
                        window.location.replace(linkFail);
                    }
                } else if (result?.reviewAnswer === 'GREEN') {
                    props.toggleSpinner(true);
                    window.location.replace(linkSuccess);
                }
            }
        }
    };

    const onError = () => {
        window.location.replace(linkFail);
    };

    const openSumSubSDK = () => {
        setCurrentScreen(SUMSUB_SDK);
    };

    const expirationHandler = async () => {
        apiFetchData(SUMSUB_FRAME_TOKEN)
            .then((json) => {
                if (json) {
                    if (json.extra) {
                        return json.extra.sumsubAccessToken;
                    }
                }
            })
            .catch((e) => {
                logInfo(e);
            });
    };

    // return (
    //     <CommonPage leftCloseIcon backUrl={AUTH_SEND_MAIN_LINK} showChat={false}>
    //         {sumsubAccessToken && (
    //             <SumsubWebSdk
    //                 accessToken={sumsubAccessToken}
    //                 expirationHandler={expirationHandler}
    //                 config={configs}
    //                 options={options}
    //                 onMessage={handleSumsubMessage}
    //                 onError={onError}
    //             />
    //         )}
    //     </CommonPage>
    // );

    const componentMap = {
        [KYC_INTRO_SCREEN]: (
            <CommonPage>
                <InfoPage
                    iconName="id-card-80"
                    iconColor="primary"
                    headerText={<DangerouslyHtml dangerouslyHtml={messages.introHeaderTitle} />}
                    secondaryText={<DangerouslyHtml dangerouslyHtml={messages.introText} />}
                    primaryButtonCaption={messages.continueButton}
                    topButtonCaption={messages.notNowButton}
                    topButtonType="link"
                    topButtonLink={AUTH_SEND_MAIN_LINK}
                    primaryButtonOnClick={openSumSubSDK}
                />
            </CommonPage>
        ),
        [SUMSUB_SDK]: (
            <CommonPage leftCloseIcon backUrl={AUTH_SEND_MAIN_LINK} showChat={false}>
                {sumsubAccessToken && (
                    <SumsubWebSdk
                        accessToken={sumsubAccessToken}
                        expirationHandler={expirationHandler}
                        config={configs}
                        options={options}
                        onMessage={handleSumsubMessage}
                        onError={onError}
                    />
                )}
            </CommonPage>
        ),
    };

    return (
        <>
            {currentScreen ? componentMap[currentScreen] : null}
            <PopupNew ref={popupRef} />
        </>
    );
};

export default connect(null, { toggleModalWithTimer, toggleSpinner })(BasePage(AntifraudSumsubFramePage));
